module.exports = __webpack_public_path__ + "static/media/note-icon.f8c5692b.svg";